export default __webpack_public_path__ + "static/media/ThirdImage.e37d76dc.png";